import React, { useContext } from "react";
import { CommonContext } from "hooks/CommonContext";
import { injectDrawerStyles } from "./drawerStyles";

injectDrawerStyles();

const JobDescription = () => {
  const { interviewDetails } = useContext(CommonContext);

  return (
    <>
      <div className="dw-header">
        <span className="dw-title">Job Description</span>
      </div>
      <div className="dw-body">
        {interviewDetails?.jobDescription?.description ? (
          <div
            className="dw-jd-content"
            dangerouslySetInnerHTML={{
              __html: interviewDetails.jobDescription.description,
            }}
          />
        ) : (
          <div className="dw-empty">No job description available.</div>
        )}
      </div>
    </>
  );
};

export default JobDescription;